export default "__VITE_ASSET__be4add0c__"